
 <div class="w-full flex flex-row justify-center font-rubik why-buy-outer-conainer">
  <div class="flex flex-col w-full font-rubik" :class="page == 'products' ? 'max-w-1140 mx-8' : 'max-w-1216 mx-5'">
    <h2 class="why-buy-h2 mb-12">Why buy from a Container Alliance partner?</h2>
    <div class="flex flex-col 1216-bp:flex-row gap-5"> 

      <div 
        class="why-buy-get-quote-container p-8 lg:p-20 1216-bp:p-10 w-full 1216-bp:w-3/5 bg-themeComponentBg-light"
      >
        <div class="hidden 1216-bp:block">
          <h2 class="why-buy-h2 mb-3">Best Pricing & Availability</h2>
          <p class="why-buy-p">
            As the largest network container suppliers in North America we can <br> provide the right 
            container for sale or rent at the right price with 
          </p>
          <span :style="page == 'partners' ? { color: organization.data.brand_color } : {color: '#4D84FF'}">availability that is unrivaled.</span>
        </div>
        <div class="1216-bp:hidden">
          <h2 class="why-buy-h2 mb-3">Best Pricing & Availability</h2>
          <p class="why-buy-p">
            As the largest network container suppliers in North America we can provide the right 
            container for sale or rent at the right price with 
            <span :style="page == 'partners' ? { color: organization.data.brand_color } : {color: '#4D84FF'}">availability that is unrivaled.</span>
          </p>
        </div>
        <button 
          class="why-buy-button border rounded-full py-2 px-1 text-black font-semibold flex items-center justify-center mt-5 transition-all"
          data-vue-init="lead-flow" data-props='{ "gtag": "get_quote"}'
        >
          Get quote
        </button>
      </div>

      <div class="w-full 1216-bp:w-2/5 flex flex-col gap-5">

        <div 
          @click="modalOpen = !modalOpen" 
          class="why-buy-card w-full h-full p-8 flex flex-col justify-evenly bg-themeComponentBg-light hover:shadow-lg transition-all"
        >
          <img 
            class="why-buy-card-img" 
            src="@/images/why-buy-from-container-alliance/largest-selection.svg" 
            alt="Largest selection"
          >
          <h3 class="why-buy-h3">Largest Selection</h3>
          <p class="why-buy-p">
            Container Alliance offers the widest selection of high quality storage - 
            shipping containers for sale or storage containers for rent.
          </p>
          <p class="why-buy-p flex gap-2">
            Search for inventories
            <img src="@/images/why-buy-from-container-alliance/search.svg" alt="Search">
          </p>
        </div>

        <a 
          href="/containers-for-sale" 
          class="why-buy-card w-full h-full p-8 flex flex-col justify-evenly bg-themeComponentBg-light hover:shadow-lg transition-all"
        >
          <img 
            class="why-buy-card-img" 
            src="@/images/why-buy-from-container-alliance/knowledge-service.svg" 
            alt="Knowledge & Service"
          >
          <h3 class="why-buy-h3">Knowledge & Service</h3>
          <p class="why-buy-p">
            Container Alliance partner companies are highly knowledgeable and will understand 
            your specific situation and provide the utmost customer care and service.
          </p>
          <p class="why-buy-p flex gap-2">
            Explore guides and resources
            <img src="@/images/why-buy-from-container-alliance/arrow_right.svg" alt="Arrow right">
          </p>
        </a>

      </div>

    </div>
  </div>

  <zipcodeModal v-if="modalOpen" @close="modalOpen = false" :solutionSlug="solutionSlug" />
</div>
